import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Note from "@/services/note";
import { EditNote } from "@/dtos/Note.dto";

/**
 * Composable for editing a note
 */
export function useEditNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (note: EditNote & { id: string }) => {
      const result = await Note.editNote(note as any);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update note");
      }
      return result.data.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["notes", variables.contactId] });
    },
  });
}
